import { useAuth } from '../../context/AuthContext'

export default function UserNav() {
  const { user, logout } = useAuth()

  if (!user) return null

  return (
    <div className="flex items-center gap-3">
      <span className="text-sm text-text-muted">
        {user.name}
        <span className="ml-1.5 rounded-full bg-surface-lowest px-2 py-0.5 text-xs font-medium text-text-faint">
          {user.role}
        </span>
      </span>
      <button
        onClick={logout}
        className="text-sm text-text-muted hover:text-accent-error transition-colors"
      >
        Log out
      </button>
    </div>
  )
}
